<template>
    <div class="service-area hidden-xs">
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-sm-6">
                    <div class="single-item text-center">
                        <div class="single-item-icon">
                            <i class="fa fa-key"></i>
                        </div>
                        <h4>Segurança <span>dos Dados</span></h4>
                        <p>Não iremos divulgar qualquer tipo de informação que identifique a sua empresa ou os negócios que realiza para nenhuma empresa terceira sem o seu consentimento.</p>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="single-item text-center">
                        <div class="single-item-icon">
                            <i class="fa fa-lock"></i>
                        </div>
                        <h4>Privacidade</h4>
                        <p>{{ app.nome }} utiliza a mesma segurança que os bancos online, garantindo o tráfego e armazenamento seguro de todos os dados de sua empresa.</p>
                    </div>
                </div>
                <div class="col-md-4 hidden-sm">
                    <div class="single-item text-center">
                        <div class="single-item-icon">
                            <i class="fa fa-save"></i>
                        </div>
                        <h4>Segurança</h4>
                        <p>Não há necessidade de gerar backup manual de seus dados, pois o nosso servidor realiza automaticamente todos os dias e armazenamos para você.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['app'],
}
</script>